export default {
  getProductPriceBreak: (state) => state.productPriceBreak,
};
